<template>
    <div class="cookies">            
        <b-container class="mt-3">
            <div class="row mt-3">
                <div class="col-12 col-md-12 mx-auto">
                    <p>Una cookie es un pequeño fragmento de texto que los sitios web que visitas envían al
                        navegador y que permite que el sitio web recuerde información sobre tu visita, como tu
                        idioma preferido y otras opciones, lo que puede facilitar tu próxima visita y hacer que el
                        sitio te resulte más útil. Las cookies desempeñan un papel muy importante, ya que sin ellas
                        el uso de la Web sería una experiencia mucho más frustrante.</p>
                    <h2>Tipos de cookies que utiliza este sitio web</h2>
                    <p>Las cookies las utilizamos con diversos fines, entre los que se incluyen recordar tus
                        preferencias de idioma, contar el número de visitas que recibimos, ayudar a registrarte en
                        nuestros servicios y proteger tus datos personales.</p>
                    <p>Una parte o la totalidad de las cookies identificadas a continuación se pueden almacenar en
                        tu navegador. En la mayoría de los casos el contenido de las cookies está encriptado para
                        mayor seguridad y privacidad del usuario.</p>
                    <table class="table table-striped cookies-table">
                        <thead>
                            <tr>
                                <th class="no-wrap">Categoría de uso</th>
                                <th>Ejemplo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <p class="category">Preferencias</p>
                                </td>
                                <td>
                                    <p>Estas cookies permiten que nuestros sitios web recuerden información que
                                        cambia el aspecto o el comportamiento del sitio como, por ejemplo, tu idioma
                                        preferido. Estas cookies también nos permiten mostrarte las fechas y horas
                                        en tu franja horaria actual.</p>
                                    <p>Todos los usuarios que accedan al sitio tendrán una cookie "language", por
                                        ejemplo, especificando tu idioma preferido para ver las páginas.</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="category">Seguridad</p>
                                </td>
                                <td>
                                    <p>Utilizamos cookies de seguridad para autenticar usuarios, evitar el uso
                                        fraudulento de credenciales de inicio de sesión y proteger los datos de
                                        usuarios frente a terceros no autorizados.</p>
                                    <p>También usamos estas cookies para firmar los envíos de formularios y evitar
                                        que ataquen nuestra infraestructura y puedan comprometer los datos que
                                        envías.</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="category">Procesos</p>
                                </td>
                                <td>
                                    <p>Las cookies de procesos permiten el funcionamiento del sitio web y ofrecen
                                        servicios esperados por el usuario que accede al sitio web. Por ejemplo
                                        permiten el acceso a áreas seguras del sitio web o el envio de formularios
                                        de contacto.</p>
                                    <p>Sin estas cookies el sitio web no puede funcionar de forma adecuada.</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="category">Estado de la sesión</p>
                                </td>
                                <td>
                                    <p>Los sitios web suelen recopilar información sobre la forma en la que los
                                        usuarios interactúan con un sitio web. Esta información nos permite, por
                                        ejemplo, identificarte como usuario o saber qué mensajes de error has
                                        recibido de determinadas páginas.</p>
                                    <p>Por ejemplo usamos una cookie denominada "SID" que nos permite identificar el
                                        ID de la cuenta de un usuario.</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="category">Analíticas</p>
                                </td>
                                <td>
                                    <p>También usamos herramientas de análisis que nos ayudan a entender el modo
                                        en el que los visitantes interactúan con el sitio web. Dichas herramientas
                                        pueden utilizar un conjunto de cookies para recopilar información e informar
                                        de las estadísticas de uso de los sitios web sin identificar personalmente a
                                        los visitantes.</p>
                                    <p><a
                                            href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">Más
                                            información sobre las cookies de Google Analytics e información sobre la
                                            privacidad</a></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h2>Revocación y eliminación de cookies</h2>
                    <p>Si lo deseas puedes eliminar las cookies instaladas en tu equipo mediante la configuración de
                        las opciones del navegador. A continuacion aparecen algunos navegadores comunes. Si el tuyo
                        no está en la lista consulta el manual de ayuda oficial donde seguramente constará cómo
                        realizar esta acción.</p>
                    <ul>
                        <li>
                            para más información sobre el navegador Google Chrome
                            <a href="https://support.google.com/chrome/answer/95582?hl=en" target="_blank">pulsa
                                aquí</a></li>
                        <li>
                            para más información sobre el navegador Mozilla Firefox
                            <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                                target="_blank">pulsa aquí</a></li>
                        <li>
                            para más información sobre el navegador Apple Safari
                            <a href="https://support.apple.com/es-es/HT201265" target="_blank">pulsa aquí</a></li>
                        <li>
                            para más información sobre el navegador Microsoft Edge
                            <a href="hhttps://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                                target="_blank">pulsa aquí</a></li>
                        <li>
                            para más información sobre el navegador Opera
                            <a href="http://help.opera.com/Windows/11.50/en/cookies.html" target="_blank">pulsa
                                aquí</a></li>
                    </ul>
                    <h2>Terceros prestadores de servicios</h2>
                    <p>Algunas cookies las procesan terceros de los que usamos algún servicio concreto, como es el servicio de mapas de 
                        <a href="https://www.google.es/intl/es/policies/technologies/cookies/" target="_blank">Google</a>
                    </p>
                </div>                
            </div>
        </b-container>  
    </div>      
</template>

<script>

export default {
    name: 'cookies',
    data() {
        return {
            titulo: "INFORMACION SOBRE COOKIES",
        }
    },
    
}
</script>